export default __webpack_public_path__ + "static/media/licenseBack.d895b980.svg";